module.exports = __webpack_public_path__ + "img/slogan.a4860112.jpg";